import React, { useEffect, useState } from "react";
import { Form, Input, Col, Row, message, Button, Select, Card } from "antd";
import { API_METHODS } from "../../constants";
import useApi from "../../hooks/useApi";
import { useNavigate } from "react-router-dom";

function PublicGrievance() {
  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const [response, request] = useApi(
    "/website/grievance",
    null,
    API_METHODS.POST
  );
  const navigate = useNavigate();

  // const [subjects, setSubjects] = useState([]);
  // const [subjectResponse, subjectRequest] = useApi(
  //   "/website/grievance/subject",
  //   null,
  //   API_METHODS.GET
  // );

  // useEffect(() => {
  //   subjectRequest();
  // }, []);

  // useEffect(() => {
  //   if (subjectResponse.data) {
  //     setSubjects(subjectResponse.data);
  //   }
  // }, [subjectResponse]);

  useEffect(() => {
    if (response.data) {
      messageApi.open({
        type: "success",
        content: "Grievance sent successfully.",
      });
      navigate("/");
    }
  }, [response]);

  const submit = () => {
    form
      .validateFields()
      .then((values) => {
        request(values);
      })
      .catch((e) => {});
  };

  return (
    <Card title="तक्रार निवारण">
      {contextHolder}
      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={16}>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="subject"
              label="तक्रारीचा विषय"
              rules={[{ required: true, message: "तक्रारीचा विषय" }]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="village"
              label="तक्रार ज्या गावातील आहे त्या गावाचे नाव"
              rules={[{ required: true, message: "गावाचे नाव." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="text"
              label="तक्रारीचा तपशील (थोडक्यात)"
              rules={[
                {
                  required: true,
                  message: "तक्रारीचा तपशील थोडक्यात.",
                },
              ]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item
              name="against_name"
              label="कोणाविरुद्ध तक्रार आहे त्याचे नाव"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="name" label="तक्रारदाराचे नाव">
              <Input />
            </Form.Item>
          </Col>
          <Col xl={8} lg={8} md={12} sm={24} xs={24}>
            <Form.Item name="mobile" label="तक्रारदाराचा संपर्क क्र.">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <>तक्रारदाराचे नाव आणि संपर्क क्रमांक गोपनीय ठेवणेत येईल</>
        <Row justify="end">
          <Form.Item label={null}>
            <Button size="large" type="primary" htmlType="submit">
              नोंद करा
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Card>
  );
}

export default PublicGrievance;
